<!-- This card is only for uploading tool images, not other image content -->
<template>
  <v-card color="primary" class="mx-auto" outlined max-width="500">
    <v-card-title class="white--text"
      >Touchstone Login Required<v-spacer />
      <v-btn
        class="mx-2"
        text
        fab
        dark
        small
        @click.stop="showHelp()"
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-card-title>

    <v-list lines="three">
      <v-list-item>
        This page allows any MIT-affiliated persons (students, postdocs, staff, faculty, and affiliates) to sign up for Fab.nano events.
      </v-list-item>
      <v-list-item>
        Please authenticate via touchstone to proceed.
      </v-list-item>
      <v-list-item>
        <a :href="this.getURL">
          <v-btn color="secondary" large class="mr-3">
            <v-icon>mdi-login</v-icon>Authenticate
          </v-btn>
        </a>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import HelpDialog from "@/support/helpMessage";

export default {
  data: () => ({}),

  computed: {
    getURL() {
      if (process.env.NODE_ENV != "production") {
        return "https://fabtools-dev.mit.edu/k/api/login?url=/api/kiosk";
      } else {
        return "https://fabtools.mit.edu/k/api/login?url=/iap";
      }
    },
  },
  methods: {
    async showHelp() {
      const aMessage = HelpDialog.GetHelpMessage();
      await this.$root.$confirmdialog("About - Fab.nano Event Signup", aMessage, {
        color: "secondary",
        reject: "",
        accept: "Okay",
      });
    },
  },
};
</script>

